// @core/api/endpoints/team/assign_team_permission_to_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AssignTeamPermissionToRoleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Assign permissions to role
 * Adds one or more permissions to a role. All members with this role gain the new capabilities immediately.
 */
export async function AssignTeamPermissionToRole(
  team_id: string,
  role_id: string,
  data: AssignTeamPermissionToRoleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/:role_id/permissions`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':role_id', encodeURIComponent(role_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
